// Pre-fills the configurator's trade-in field from #trade=… links (sell page offer, GPU product pages).
// The hash is captured into sessionStorage by an inline script in layout/theme.liquid before the configurator boots.
(() => {
  let text = '';
  try { text = sessionStorage.getItem('rc2.trade') || ''; } catch {}
  if (!text) return;
  const root = document.querySelector('[data-rc2]');
  if (!root) return;
  const apply = () => {
    const box = root.querySelector('input[data-act="trade"]');
    if (!box) return false;
    if (!box.checked) { box.checked = true; box.dispatchEvent(new Event('change', {bubbles: true})); }
    const area = root.querySelector('[data-rc2-trade]');
    if (!area) return false;
    if (!area.value.trim()) { area.value = text.slice(0, 600); area.dispatchEvent(new Event('input', {bubbles: true})); }
    area.blur();
    try { sessionStorage.removeItem('rc2.trade'); } catch {}
    return true;
  };
  if (apply()) return;
  const mo = new MutationObserver(() => { if (apply()) mo.disconnect(); });
  mo.observe(root, {childList: true, subtree: true});
})();
